// extracted by mini-css-extract-plugin
export default {"login":"Login_login__Cih-z","alert":"Login_alert__-k4mS"};